/**
 * 新版公共登录体系，兼容pc端，app端，微信端
 */
import wechatLogin from './wechatLogin.js'
// import createHttp from '../tools/axios'
import { getRunningEnv } from '../tools/getPlatform'
let { env } = getRunningEnv()
let HOST = `https://m${env ? `-${env}` : ''}.xinli001.com`
let api = {
  getUserHeader: `${HOST}/ajax/get-user-header`
}
class Login extends wechatLogin {
  constructor(
    name,
    {
      getWxAuthParams = {},
      wechatGetUserParams = {},
      getUserHeaderParams = {},
      ...commonData
    } = {}
  ) {
    super(name, {
      getWxAuthParams,
      wechatGetUserParams,
      commonData
    })
    this.name = name
    this.getUserHeaderParams = getUserHeaderParams
    this.commonData = commonData

    this.logInUrl = `${location.protocol}//m${
      env !== '' ? '-' + env : ''
    }.xinli001.com/account/login`
    this.fetchUserPromise = null
    this.initLogin()
  }
  initLogin() {}
  // 平台登录方法,平台的接口登录失效时调用的方法
  login(auth_type) {
    return this.fetchUserInfo({ cache: false }).catch(() => {
      return this.goLogin(auth_type)
    })
  }

  goLogin(auth_type = 'manual') {
    console.log('this.commonData', this.commonData)
    const { cache = true } = this.commonData
    if (this.$platform.isWechat) {
      let params = { getWxAuthParams: { auth_type }, cache }
      let auto_manual = window.sessionStorage.getItem('getWxAuth_auto_manual')
      // if (!auto_manual || (!auto_manual.includes('manual') && auth_type !== auto_manual)){
      if (!auto_manual || (auto_manual === 'auto' && auth_type === 'manual')) {
        // 1、没有缓存；2、上次是静默授权，这次是主动授权；以上两种情况不走缓存
        params.cache = false
        window.sessionStorage.setItem('getWxAuth_auto_manual', auth_type)
      }
      return this.getWxAuth(params)
    } else if (this.$platform.isYixinliApp) {
      window.location.replace('yixinli://open_user_login')
      return Promise.reject({
        code: 302,
        message: '请先注册登录，页面即将跳转...'
      })
    } else {
      window.location.replace(
        this.logInUrl + `?next=${encodeURIComponent(location.href)}`
      )
      return Promise.reject({
        code: 302,
        message: '请先注册登录，页面即将跳转...'
      })
    }
  }
  /**
   * 以下三个方法查询是否登录，若登录直接调用resolve，失败则去进行登录，兼容非微信端
   * 主动授权
   * @param cache 默认使用js中缓存的用户信息，传入false则调用接口去请求用户信息
   */
  queryLoginStatus({ cache = true, auth_type } = {}) {
    if (cache && this.userInfo) {
      return Promise.resolve(this.userInfo)
    } else {
      return this.login(auth_type)
    }
  }

  /**
   * 主动授权登录
   */
  manuallyAuth({ cache = true } = {}) {
    return this.queryLoginStatus({ cache, auth_type: 'manual' })
  }
  /**
   * 静默授权--建议在页面访问的时候使用
   * 当前方法必须配合主动授权使用。因为会刷新一下页面，新用户还会获取不到用户信息。
   * 但是老用户在页面访问的时候就直接可以获取到用户信息，不需要再点击按钮。
   */
  silentAuth({ cache = true } = {}) {
    return this.queryLoginStatus({ cache, auth_type: 'auto' })
  }

  /**
   * 先静默授权-不成功再主动授权
   * 重点---当前方法只能在页面访问的时候调用
   */
  silentManuallyAuth({ cache = true } = {}) {
    return this.silentAuth({ cache }).catch(err => {
      if (+err.code === 10005) {
        this.manuallyAuth({ cache })
      }
      return Promise.reject(err)
    })
  }
  /**
   * 获取用户信息,用接口查询用户时候登录状态,不强制登录
   * @param cache 默认使用js中缓存的用户信息，传入false则调用接口去请求用户信息
   */
  fetchUserInfo({
    cache = true,
    getUserHeaderParams = {},
    wechatGetUserParams = {}
  } = {}) {
    if (cache && this.userInfo) {
      return Promise.resolve(this.userInfo)
    } else if (this.fetchUserPromise) {
      return this.fetchUserPromise
    } else if (this.$platform.isWechat) {
      // 因为授权回来后，要先再调用一次授权的接口获取open_id然后再能获取到用户信息
      if (this.initWechatLoginStatus()) {
        return this.getWxAuth()
      } else if (this.fetchWxAuthPromise) {
        return this.fetchWxAuthPromise
      } else {
        return (this.fetchUserPromise = this.wechatFetchUserInfo({
          wechatGetUserParams
        }))
      }
    } else {
      return (this.fetchUserPromise = this.fetchUserHeader({
        getUserHeaderParams
      }))
    }
    // return Promise.reject()
  }
  // 非微信端请求用户信息接口
  fetchUserHeader({ getUserHeaderParams = {} } = {}) {
    let params = {}
    params = Object.assign(
      params,
      this.getUserHeaderParams,
      getUserHeaderParams
    )
    return new Promise((resolve, reject) => {
      this.$http
        .get(api.getUserHeader, {
          params
        })
        .then(({ data: res }) => {
          if (
            +res.code === 0 &&
            res.data.user.lingxi_info &&
            res.data.user.lingxi_info.userKey
          ) {
            this.userInfo = {
              userKey: res.data.user.lingxi_info.userKey,
              userId: res.data.user.id,
              collegeOpenid: res.data.user.wx_college_openid,
              openId: res.data.user.wx_openid,
              unionId: res.data.user.wx_unionid,
              token: res.data.user.token,
              nickname: res.data.user.nickname,
              avatar: res.data.user.avatar,
              ...res.data
            }
            resolve(this.userInfo)
          } else {
            reject(res)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
function singleton() {
  let instance
  /**
   * @param {String} name 使用什么公众号登录，必传
   * @param {Object} commonData 配置数据
   * @param {Object} commonData.getWxAuthParams 请求get-wx-auth.json接口参数
   * @param {Object} commonData.wechatGetUserParams 微信端请求用户信息接口参数
   * @param {Object} commonData.wechatGetUserParams.asyncLingXi 用户信息需要同步灵犀的传true(学院、测评必传true)，不传或是false会导致查询不到userKey
   * @param {Object} commonData.getUserHeaderParams 非微信端get-user-header请求用户信息接口参数
   * userInfo，因为微信端跟非微信端获取的接口不同，数据结构不同
   * @param {Function} commonData.hookGetWxAuthSuccess get-wx-auth.json接口返回成功后（code为0）触发的钩子函数
   * */
  return function(name, commonData) {
    if (instance) {
      return instance
    } else if (name) {
      return (instance = new Login(name, commonData))
    } else if (!name) {
      throw new Error(
        `frontend-lib\\login\\login.js:初始化new Login没有指定name`
      )
    }
  }
}
export default singleton()
